<div class="modal-content">
    <div class="chest-spotlight"></div>
    <div class="chest-spotlight spotlight-2"></div>
    <div class="chest-spotlight spotlight-3"></div>

    <div class="win-up-to-text-wrap">
        <img src="/assets/images/v2/jackpot/open-chest/win-up-to.svg" alt="">
    </div>

    <div class="chest-open-wrap">
        <app-form-button class="small" *ngIf="chests > 1 && !openChest" (click)="openAllJackpotChests()">Open all chests</app-form-button>
        <div class="chest-wrap">
            <img src="/assets/images/v2/jackpot/open-chest/chest.svg" *ngIf="!openChest" class="chest-closed" (click)="openJackpotChest()">
            <img src="/assets/images/v2/jackpot/open-chest/chest-bottom.svg" *ngIf="openChest" class="chest-bottom">
            <img src="/assets/images/v2/jackpot/open-chest/chest-top.svg" *ngIf="openChest" class="chest-top">
            <div class="chest-blur" *ngIf="openChest"></div>
            <div class="chest-key" *ngIf="openChest"></div>
            <div class="chest-keys-count" *ngIf="openChest">X{{ keysReceived }}</div>
        </div>
    </div>
    <div class="user-info-wrap">
        <div class="user-info">
            <div class="jackpot-key"></div> {{ keys }} keys
        </div>
        <div class="user-info">
            <div class="jackpot-chest"></div> {{ chests }} chests
        </div>
    </div>

    <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup">
        <i class="fal fa-times"></i>
    </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/open-chest-new/open-chest-modal.template.html